var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-steps',{attrs:{"active":_vm.step,"space":200,"simple":""}},_vm._l((_vm.steps),function(s,i){return _c('el-step',{key:i,attrs:{"icon":i === 0 ? 'el-icon-edit' : 'el-icon-tickets',"title":i === 0 ? 'Gestión de riesgos' : 'Procedimiento de trabajo',"description":_vm.$t(s)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }